<script>
import FormGroup from "@/components/molecules/form-group";
import FormRadio from "@/components/molecules/form-radio";
import Button from "@/components/atoms/button";
import Titre from "@/components/atoms/titre";

export default {
  name: "AddressLadNormalisation",
  components: {
    FormRadio,
    Button,
    FormGroup,
    Titre
  },
  props: {
    userAdresse: {
      type: Object,
      required: true
    },
    suggestionAdresse: {
      type: Object,
      required: true
    }
  },
  emits: ["updateAdresse"],
  data() {
    return {
      isSuggestionSelected: null
    };
  },
  methods: {
    selectAdresse() {
      const newAdresse = this.userAdresse;
      if (this.isSuggestionSelected) {
        newAdresse.attributes.adresse =
          this.suggestionAdresse.attributes.adresse;
        if (this.suggestionAdresse.attributes.complement) {
          newAdresse.attributes.complement_adresse =
            this.suggestionAdresse.attributes.complement;
        }
        newAdresse.attributes.normalisee = true;
      }
      newAdresse.attributes.normalisation_proposee = true;
      this.$emit("updateAdresse", newAdresse);
    }
  }
};
</script>

<template>
  <div>
    <Titre
      tag="h1"
      variant="primary"
      size="md"
      class="u-mb-md u-text-center"
    >
      Vérifier votre adresse de livraison
    </Titre>

    <p class="u-mb-lg u-text-center">
      Pour vous assurer une meilleure qualité de livraison, <br>
      nous vous recommandons une adresse aux normes postales. <br>
      Si elle ne vous convient pas vous pouvez conserver votre adresse ou la modifier.
    </p>

    <p class="u-font-500 u-text-center u-mb-md">
      Choisissez l’adresse de livraison à utiliser
    </p>

    <FormGroup
      size="xlg"
      center
    >
      <FormRadio
        v-model="isSuggestionSelected"
        :value="true"
        name="address"
        block
      >
        <span class="c-address-lad-normalisation__radio-label u-font-15">
          <strong class="u-font-500 u-color-success">Notre suggestion</strong>
          <span class="u-font-400">
            {{ userAdresse.attributes.prenom }} {{ userAdresse.attributes.nom }}<br>
            {{ suggestionAdresse.attributes.adresse }}<br>
            <template v-if="suggestionAdresse.attributes.complement">
              {{ suggestionAdresse.attributes.complement }}<br>
            </template>
            <template v-else-if="userAdresse.attributes.complement_adresse">
              {{ userAdresse.attributes.complement_adresse }}<br>
            </template>
            {{ userAdresse.attributes.code_postal }} {{ userAdresse.attributes.nom_commune }}
          </span>
        </span>
      </FormRadio>

      <FormRadio
        v-model="isSuggestionSelected"
        :value="false"
        name="address"
        block
        class="u-mt-sm"
      >
        <span class="c-address-lad-normalisation__radio-label u-font-15">
          <strong class="u-font-500 u-color-text-light">Votre saisie</strong>
          <span class="u-font-400">
            {{ userAdresse.attributes.prenom }} {{ userAdresse.attributes.nom }}<br>
            {{ userAdresse.attributes.adresse }}<br>
            <template v-if="userAdresse.attributes.complement_adresse">
              {{ userAdresse.attributes.complement_adresse }}<br>
            </template>
            {{ userAdresse.attributes.code_postal }} {{ userAdresse.attributes.nom_commune }}
          </span>
        </span>
      </FormRadio>
    </FormGroup>

    <div class="u-text-center u-mt-md">
      <Button
        variant="primary"
        radius="full"
        size="md"
        :disabled="isSuggestionSelected === null"
        @click="selectAdresse()"
      >
        Je valide cette adresse
      </Button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.c-address-lad-normalisation__radio-label {
  display: inline-flex;
  flex-direction: column;
  row-gap: spacing(xs);
}
</style>
